import React, { useState, useEffect } from 'react';

import UserService from 'Services/UserService';
import FonctionService from 'Services/FonctionService';

import { Form, Button, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import { Formik } from 'formik';
import * as yup from 'yup';
import Select from 'react-select';

import { toast } from 'react-toastify';
import { toReactSelectObject } from 'Utils/Helpers';

const schema = yup.object({
    UserName: yup.string().required(),
    Email: yup.string().email().required(),
    FirstName: yup.string().required(),
    LastName: yup.string().required(),
    Password: yup.string().min(3),
    FonctionId: yup.string().required(),
    Admin: yup.boolean(),
    Active: yup.boolean(),
    Disabled: yup.boolean(),
    SendMAIL: yup.boolean(),
});

const UserCreateOrEdit = (props) => {
    // const { register, handleSubmit, errors } = useForm();
    const [user, setUser] = useState(null);
    const [fonctions, setFonctions] = useState([]);
    const history = useHistory();

    const {
        match: { params },
    } = props;

    useEffect(() => {
        FonctionService.getFonctions()
            .then((result) => {
                if (result.status === 200) {
                    setFonctions(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        if (params.userId) {
            UserService.getUserById(params.userId)
                .then((result) => {
                    if (result.status === 200) {
                        setUser(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const submitForm = (data) => {
        // console.log('formData', data);
        UserService.saveUser({ userId: params.userId, ...data })
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/user/index');
                    toast.success('Action a été exécutée avec succès.');
                }
            })
            .catch((ex) => {
                console.log(ex);
                toast.error("Une erreur s'est produite !");
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/user/index' }}>
                    Users
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{params.userId ? 'Edit User' : 'Create New User'}</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.userId ? 'Edit User' : 'Create New User'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.userId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            UserName: user ? user.userName : '',
                            FirstName: user ? user.firstName : '',
                            LastName: user ? user.lastName : '',
                            Email: user ? user.email : '',
                            Password: undefined,
                            FonctionId: user ? user.fonctionId : '',
                            Admin: user ? user.admin : false,
                            Active: user ? user.active : false,
                            Disabled: user ? user.disabled : false,
                            SendMAIL: false,
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors, setFieldValue, setFieldTouched }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="first name"
                                        name="FirstName"
                                        value={values.FirstName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.FirstName}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.FirstName}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="last name"
                                        name="LastName"
                                        value={values.LastName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.LastName}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.LastName}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea2">
                                    <Form.Label>UserName</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="UserName"
                                        name="UserName"
                                        value={values.UserName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.UserName}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.UserName}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="email"
                                        name="Email"
                                        value={values.Email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.Email}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.Email}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea4">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="password"
                                        name="Password"
                                        value={values.Password}
                                        onChange={handleChange}
                                        isInvalid={!!errors.Password}
                                        autoComplete="false"
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.Password}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group controlId="exampleForm.ControlTextarea99">
                                    <Form.Label>Fonction</Form.Label>
                                    <Select
                                        name="FonctionId"
                                        value={toReactSelectObject(
                                            fonctions.find((fonction) => fonction.fonctionId === values.FonctionId),
                                            'name',
                                            'fonctionId',
                                        )}
                                        onChange={(option) => setFieldValue('FonctionId', option.value)}
                                        options={fonctions.map((fonction) =>
                                            toReactSelectObject(fonction, 'name', 'fonctionId'),
                                        )}
                                        isInvalid={!!errors.FonctionId}
                                        onBlur={() => setFieldTouched('FonctionId', true)}
                                        placeholder="-"
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.FonctionId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox">
                                    <Form.Check
                                        type="checkbox"
                                        label="Admin"
                                        name="Admin"
                                        checked={values.Admin}
                                        onChange={handleChange}
                                        isInvalid={!!errors.Admin}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.Admin}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox2">
                                    <Form.Check
                                        type="checkbox"
                                        label="Active"
                                        name="Active"
                                        checked={values.Active}
                                        onChange={(e) => {
                                            handleChange(e);
                                            if (e.target.checked === true) {
                                                handleChange({
                                                    target: {
                                                        name: 'SendMAIL',
                                                        value: false,
                                                    },
                                                });
                                            }
                                        }}
                                        isInvalid={!!errors.Active}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.Active}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Disabled"
                                        name="Disabled"
                                        checked={values.Disabled}
                                        onChange={(e) => {
                                            handleChange(e);
                                            if (e.target.checked === true) {
                                                handleChange({
                                                    target: {
                                                        name: 'SendMAIL',
                                                        value: false,
                                                    },
                                                });
                                            }
                                        }}
                                        isInvalid={!!errors.Disabled}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.Disabled}</Form.Control.Feedback>
                                </Form.Group>
                                {!params.userId && (
                                    <Form.Group controlId="formBasicCheckbox4">
                                        <Form.Check
                                            type="checkbox"
                                            label="Send MAIL"
                                            name="SendMAIL"
                                            checked={values.SendMAIL}
                                            onChange={(e) => {
                                                handleChange(e);
                                                if (e.target.checked === true) {
                                                    handleChange({
                                                        target: {
                                                            name: 'Active',
                                                            value: false,
                                                        },
                                                    });
                                                    handleChange({
                                                        target: {
                                                            name: 'Disabled',
                                                            value: false,
                                                        },
                                                    });
                                                }
                                            }}
                                            isInvalid={!!errors.SendMAIL}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.SendMAIL}</Form.Control.Feedback>
                                    </Form.Group>
                                )}
                                <Button variant="primary" type="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        )}
                    </Formik>
                    {/* {errors.exampleRequired && <span>This field is required</span>}

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="first name"
                                name="FirstName"
                                defaultValue={user ? user.firstName : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="last name"
                                name="LastName"
                                defaultValue={user ? user.lastName : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="email"
                                name="Email"
                                defaultValue={user ? user.email : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="password"
                                name="password"
                                defaultValue={user ? user.password : ''}
                                ref={register}
                            />
                        </Form.Group>{' '}
                        <Form.Group controlId="exampleForm.ControlSelect1">
                            <Form.Label>Fonction</Form.Label>
                            <Form.Control
                                as="select"
                                name="fonctionId"
                                value={user ? user.fonctionId : ''}
                                ref={register}
                            >
                                <option value="">-</option>
                                {fonctions &&
                                    fonctions.map((fonction, key) => {
                                        return (
                                            <option value={fonction.fonctionId} key={key}>
                                                {fonction.name}
                                            </option>
                                        );
                                    })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formBasicCheckbox">
                            {user && console.log('userAdmin', user.admin)}
                            <Form.Check
                                type="checkbox"
                                label="Admin"
                                name="Admin"
                                defaultChecked={user ? user.admin : false}
                                ref={register}
                                // onChange={console.log('changed')}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" block>
                            Submit
                        </Button>
                    </Form> */}
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default UserCreateOrEdit;
